import { useEffect } from "react";

/**
 * 處理中的時候，防止使用者意外關閉視窗 / 切換 tab。
 * 觸發後瀏覽器會跳原生確認對話框（訊息文字無法自訂）。
 */
export function useBeforeUnload(active: boolean, message?: string) {
  useEffect(() => {
    if (!active) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // returnValue 在新版瀏覽器只是觸發確認，文字是瀏覽器預設的
      e.returnValue = message ?? "處理中，離開會中斷正在處理的程序";
      return e.returnValue;
    };

    const visibilityHandler = () => {
      if (document.hidden && "Notification" in window && Notification.permission === "granted") {
        new Notification("ChillMeet", {
          body: "處理仍在進行，請保持此分頁開啟",
        });
      }
    };

    window.addEventListener("beforeunload", handler);
    document.addEventListener("visibilitychange", visibilityHandler);

    // 主動請求 Notification 權限
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
    }

    return () => {
      window.removeEventListener("beforeunload", handler);
      document.removeEventListener("visibilitychange", visibilityHandler);
    };
  }, [active, message]);
}
